import { Suspense } from 'react';
import { SellerPayoutsClient } from './seller-payouts-client';

export default function Page() {
  return (
    <Suspense fallback={null}>
      <SellerPayoutsClient />
    </Suspense>
  );
}
